import React, { useEffect, useState } from "react";
import {
  getDateDayOfWeek,
  dateDayOfWeekPost,
} from "../../../server/DeliveryTimeEdit";
import showAlert from "../../../server/ShowAlert";
import { useDispatch } from "react-redux";
import { setPreload } from "../../../server/CartsOpen";

const DeliveryTimeDayOfWeek = ({ dayTypes }) => {
  const dispatch = useDispatch();
  const [dayOfWeek, setDayOfWeek] = useState([]);

  useEffect(() => {
    GetDateDayOfWeek();
  }, []);

  const HandleDayTypeId = (value, checkedItem) => {
    const day = [...dayOfWeek];
    const index = dayTypes.findIndex((x) => x.Id === checkedItem);
    day[index].DateTypeId = value;
    setDayOfWeek(day);
  };

  const GetDateDayOfWeek = () => {
    getDateDayOfWeek()
      .then((x) => {
        setDayOfWeek(x.data);
      })
      .catch(() => console.log("error"));
  };

  const saveChanges = (id) => {
    dispatch(setPreload(true));
    const changeDayType = dayOfWeek.find((x) => x.Id === id);
    dateDayOfWeekPost(changeDayType)
      .then((x) => {
        if (x.data) {
          showAlert({ msgTitle: "השינויים נשמרו בהצלחה.", msgType: "success" });
        }
      })
      .catch(() =>
        showAlert({
          msgTitle: " הייתה בעיה בשמירת הנתונים.",
          msgType: "error",
        }),
      )
      .finally(() => dispatch(setPreload(false)));
  };

  return (
    <section className="delivery-section delivery-time-day-of-week">
      <h2 className="admin-section-title">ימי השבוע</h2>
      <div className="table-data">
        <table>
          <thead>
            <tr>
              <th>שם יום</th>
              <th>סוג יום</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dayOfWeek.length
              ? dayOfWeek.map((x) => (
                  <tr key={x.Id}>
                    <td>{x.Name}</td>
                    <td>
                      <select
                        className="select-day-type admin-input"
                        onChange={(e) => HandleDayTypeId(e.target.value, x.Id)}
                        value={x.DateTypeId}
                      >
                        {dayTypes.map((item) => (
                          <option key={item.Id} value={item.Id}>
                            {item.Name}({item.Start}-{item.End})
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn"
                        onClick={() => saveChanges(x.Id)}
                      >
                        שמור
                      </button>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default DeliveryTimeDayOfWeek;
